import "./CampaignStatusBadge.css";
import {
  MessageCampaignStatus,
  MESSAGE_CAMPAIGN_STATUS_CLASS,
  MESSAGE_CAMPAIGN_STATUS_LABELS,
} from "../../../models/MessageModels";

interface CampaignStatusBadgeProps {
  status: number;
}

const CampaignStatusBadge = ({ status }: CampaignStatusBadgeProps) => {
  const key = status as MessageCampaignStatus;
  const label = MESSAGE_CAMPAIGN_STATUS_LABELS[key] ?? "Unknown";
  const cls = MESSAGE_CAMPAIGN_STATUS_CLASS[key] ?? "pending";

  return (
    <span className={`msg-campaign-status msg-campaign-status--${cls}`}>
      {label}
    </span>
  );
};

export default CampaignStatusBadge;